import { getUriForCollection } from '../utils/uri';

import { processCategories } from './process';

import { CollectionTypes, Constant } from '~/types/adamTypes';

import type { ContentImportParams } from '~/types/app';

import { dataSave } from '~/lib/data/save';

import type { NomadDB } from '~/db/NomadDB';

import type { ProgressMamager } from '#imports';

export const dataImportUserContent = (db: NomadDB, nomadFetch: Function) => {
  const { saveLibraryBookCollectionItems } = dataSave(db);

  const _processResultAndSave = async (
    libraryBookId: string,
    collection: CollectionTypes,
    items: any[],
    source?: string
  ) => {
    items = items.map((item) => {
      return source != null
        ? { ...item, libraryBookId, source }
        : { ...item, libraryBookId };
    });

    await saveLibraryBookCollectionItems(
      libraryBookId,
      collection,
      items,
      source
    );
  };

  const importUserContentCollection = async (
    libraryBookId: string,
    collection: CollectionTypes,
    data: any,
    source?: string
  ): Promise<void> => {
    switch (collection) {
      case CollectionTypes.Exercises: {
        let { exerciseItems, exercises, medias } = data;

        if (!exercises) exercises = [];
        if (!exerciseItems) exerciseItems = [];
        if (!medias) medias = [];

        medias.forEach((media) => media.source === CollectionTypes.Exercises);
        // TODO @Philippe add code below inside Adam
        exercises.forEach((exercise) => {
          exercise.type = 'exercise';
          exercise.contentType = 'exercise';
          if (!exercise.gameplayOptions) {
            exercise.gameplayOptions = {
              duration: 120,
              mixed: true,
              timed: false,
            };
          }
        });
        exerciseItems.forEach((item) => {
          if (!item.maxPoints) item.maxPoints = 1;
        });

        // and remove

        await _processResultAndSave(
          libraryBookId,
          CollectionTypes.Exercises,
          exercises,
          source
        );
        await _processResultAndSave(
          libraryBookId,
          CollectionTypes.ExerciseItems,
          exerciseItems,
          source
        );
        await _processResultAndSave(
          libraryBookId,
          CollectionTypes.Media,
          medias,
          CollectionTypes.Exercises
        );
        break;
      }
      case CollectionTypes.Media: {
        await _processResultAndSave(
          libraryBookId,
          collection,
          data,
          CollectionTypes.Media
        );
        break;
      }
      case CollectionTypes.Categories: {
        processCategories(libraryBookId, data);
        await _processResultAndSave(libraryBookId, collection, data);
        break;
      }
      default:
        await _processResultAndSave(libraryBookId, collection, data);
        break;
    }
  };

  const fetchtAndSaveUserContentCollection = async (
    libraryBookId: string,
    collection: CollectionTypes,
    segmented: 0 | 1,
    adaptive: 0 | 1
  ): Promise<void> => {
    let params;
    if (adaptive === 1) {
      params = {
        adaptive,
      };
    } else {
      params = {
        libraryBookId,
        segmented,
      };
    }

    const request = await nomadFetch(getUriForCollection(collection), {
      params,
    });

    const { result } = request;

    await importUserContentCollection(libraryBookId, collection, result);
  };

  const getImportContentCalls = (
    contentImportParam: ContentImportParams,
    progressManager: ProgressMamager
  ): Function[] => {
    const calls: Function[] = [];
    const { libraryBookId, collections, segmented, adaptive } =
      contentImportParam;

    collections.forEach((collection) => {
      progressManager.incTotal();
      calls.push(async () => {
        await fetchtAndSaveUserContentCollection(
          libraryBookId,
          collection,
          segmented,
          adaptive
        );
        progressManager.incProgress();
      });
    });
    return calls;
  };

  return {
    getImportContentCalls,
    importUserContentCollection,
  };
};
